import {ApplicationContext} from './api';
import {RoleContextSwitch} from './RoleContextSwitch';

// Issue #530 founder three-role evaluation: one identity may hold separate customer, process-server
// and Mission Control memberships. Every authenticated route names the role context the server
// derived from the active organization, and offers the audited organization switch, so a founder
// evaluating one role can never mistake it for another. Labels are presentation only; access is
// still recomputed server-side from the session organization on every request.
export function roleContextLabel(context:ApplicationContext):string{
  if(context.capabilities.mission_control||context.capabilities.fulfillment_routing)return 'Mission Control administrator';
  if(context.workspace_kind==='limited'&&(context.capabilities.process_server_onboarding===true||context.capabilities.process_server_roster===true||context.capabilities.internal_mfa_requirements===true))return 'Mission Control administration';
  switch(context.workspace_kind){
    case 'platform_owner':return 'Platform owner';
    case 'company_administrator':return 'Company administrator';
    case 'process_server':return 'Process server (field)';
    case 'customer':return 'Customer';
    default:return 'Limited access';
  }
}

export function RoleContextBar({context}:{context:ApplicationContext}){
  return <section className="role-context-bar" aria-label="Current role context">
    <p><span>Viewing as</span> <strong>{roleContextLabel(context)}</strong> <span>for</span> <strong>{context.organization.display_name}</strong></p>
    <RoleContextSwitch activeOrganizationId={context.organization.organization_id}/>
  </section>;
}
